// A Custom User Key field looks like {{ KEY }}
function isCustomKeyField(value: string): boolean {
  if (
    value.length > 3 &&
    value.includes("{") &&
    value.includes("}") &&
    value.indexOf("{") < value.indexOf("}") - 1
  ) {
    return true;
  }
  return false;
}

export default isCustomKeyField;
